/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Text, View } from '@az/starc-ui';
import styles from './styles.module.scss';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { ProductCompareDescriptions } from '../../../../../api/types/products-types';
import { useLocale } from '@/hooks/useLocale';
import { useLabels } from '@/hooks/useLabels';

export const labelMap = {
  label_pdpFeatures_h1: 'label_pdpFeatures_h1',
};

/**
 * PdpFeatures is a new section added with the PDP Redesign. It displays a bulleted list of Znet
 * data from productCompareDescriptions in the ACES /products response.
 */
export const PdpFeatures = ({
  productCompareDescriptions,
}: {
  productCompareDescriptions?: ProductCompareDescriptions | null;
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const locale = useLocale().toUpperCase().replaceAll('-', '_');
  const features = productCompareDescriptions?.[locale as 'EN_US' | 'ES_MX' | 'PT_BR'];
  const { label_pdpFeatures_h1 } = useLabels(labelMap);

  return (
    <View direction="column" className={styles.featuresContainer}>
      <Text
        variant="small-body"
        weight="bold"
        attributes={{ style: { fontSize: isMobile ? '12px' : '14px' } }}
      >
        {`${label_pdpFeatures_h1}:`}
      </Text>
      <View.Item gapBefore={1}>
        <View as="ul">
          {features?.map((feat: string, index: number) => {
            return (
              <View.Item as="li" key={`${index}${feat}`}>
                <Text
                  variant="small-body"
                  attributes={{ style: { fontSize: isMobile ? '12px' : '14px' } }}
                >
                  {feat}
                </Text>
              </View.Item>
            );
          })}
        </View>
      </View.Item>
    </View>
  );
};
